import { Language } from '../types';
import formatTime from './formatTime';
export var errorGenerator = function (config) {
    switch (config.language) {
        case Language.He:
            return config.heError;
        case Language.En:
            return config.enError;
        default:
            throw new Error();
    }
};
export var greaterThan = function (language, name, limit) { return errorGenerator({
    language: language,
    heError: name + " \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05DB\u05D9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA " + limit + " \u05EA\u05D5\u05D5\u05D9\u05DD",
    enError: "The " + name + " must be at least " + limit + " characters long"
}); };
export var smallerThan = function (language, name, limit) { return errorGenerator({
    language: language,
    heError: name + " \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05DB\u05D9\u05DC \u05E2\u05D3 " + limit + " \u05EA\u05D5\u05D5\u05D9\u05DD",
    enError: "The " + name + " only be up to " + limit + " characters long"
}); };
export var length = function (language, name, limit) { return errorGenerator({
    language: language,
    heError: name + " \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05DB\u05D9\u05DC " + limit + " \u05EA\u05D5\u05D5\u05D9\u05DD \u05D1\u05D3\u05D9\u05D5\u05E7",
    enError: "The " + name + " must be " + limit + " characters long"
}); };
export var regex = function (language, name, error) { return errorGenerator({
    language: language,
    heError: (name || 'שדה זה') + " " + (error || 'אינו תקין'),
    enError: (name ? "The " + name : 'This field') + " " + (error || 'is invalid')
}); };
export var required = function (language) { return errorGenerator({
    language: language,
    heError: 'שדה זה הינו חובה',
    enError: 'This field is required'
}); };
export var confirm = function (language) { return errorGenerator({
    language: language,
    heError: 'השדות אינם זהים',
    enError: 'The fields do not match'
}); };
export var image = function (language) { return errorGenerator({
    language: language,
    heError: 'סוג הקובץ אינו תקין',
    enError: 'Invalid file type'
}); };
export var dateBefore = function (language, date) { return errorGenerator({
    language: language,
    heError: "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05E9\u05D4\u05D5\u05D6\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DC\u05E4\u05E0\u05D9 " + date.toLocaleDateString(),
    enError: "The entered date must be before " + date.toLocaleDateString()
}); };
export var dateAfter = function (language, date) { return errorGenerator({
    language: language,
    heError: "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05E9\u05D4\u05D5\u05D6\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D0\u05D7\u05E8\u05D9 " + date.toLocaleDateString(),
    enError: "The entered date must be after " + date.toLocaleDateString()
}); };
export var timeBefore = function (language, date) { return errorGenerator({
    language: language,
    heError: "\u05D4\u05D6\u05DE\u05DF \u05E9\u05D4\u05D5\u05D6\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DC\u05E4\u05E0\u05D9 " + formatTime(date, language),
    enError: "The entered time must be before " + formatTime(date, language)
}); };
export var timeAfter = function (language, date) { return errorGenerator({
    language: language,
    heError: "\u05D4\u05D6\u05DE\u05DF \u05E9\u05D4\u05D5\u05D6\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D0\u05D7\u05E8\u05D9 " + formatTime(date, language),
    enError: "The entered time must be after " + formatTime(date, language)
}); };
export var timeMinRange = function (language, hours) { return errorGenerator({
    language: language,
    heError: "\u05D4\u05D6\u05DE\u05DF \u05E9\u05D4\u05D5\u05D6\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DC\u05E4\u05D7\u05D5\u05EA " + hours + " \u05E9\u05E2\u05D5\u05EA",
    enError: "The entered time must be at least " + hours + " hours"
}); };
export var fileNameLength = function (language) { return errorGenerator({
    language: language,
    heError: 'שם הקובץ ארוך מדי',
    enError: 'The name of the file is too long'
}); };
//# sourceMappingURL=error-generators.js.map